import update from 'immutability-helper'
import _ from 'lodash'
import {
    SHIPMENT_LIST_FETCHED,
    SHIPMENT_MODEL_LOADED,
    SET_NEW_SHIPMENT_MODEL,
    SHIPMENT_MODEL_UPDATED_BY_FORM,
    NEW_SHIPMENT_MODEL_HEADER_UPDATED_BY_FORM,
    NEW_SHIPMENT_MODEL_LINES_QUANTITY_UPDATED_BY_FORM,
    NEW_SHIPMENT_MODEL_COMMENT_UPDATED_BY_FORM,
    SHIPMENT_IS_FULFILLED,
    SHIPMENT_IS_UNFULFILLED,
    TRANSACTION_LIST_FETCHED,
    TRANSACTION_DOC_NUMBER_UPDATED,
    SET_SHIPMENT_IN_TRANSACTION_MODEL,
    SHIPMENT_INVOICE_NUMBER_UPDATED_BY_FORM,
    SHIPMENT_LINE_PRICE_UPDATED_BY_FORM,
    SHIPMENT_INVOICE_DATE_UPDATED,
    SHIPMENT_ORDER_TAX_CODE_UPDATED
} from '../actions/types'

export default function shipment(state = {
    list: {
        on_page: 1,
        per_page: 15,
        total_count: 0,
        data: []
    },
    model: {
        header: {

        },
        lines: [

        ],
        comment: ""
    },
    shipment: {
        
    },
    transaction_list: {
        on_page: 1,
        per_page: 15,
        total_count: 0,
        data: []
    },
    qb_bill: {
        id: null,
        invoice_number: ''
    }
}, action = {}) {
    switch(action.type) {
        case SET_SHIPMENT_IN_TRANSACTION_MODEL:
            return update(state, {
                qb_bill: {$set: action.payload}
            });

        case SHIPMENT_INVOICE_NUMBER_UPDATED_BY_FORM:
            return update(state, {
                qb_bill: {
                    invoice_number: {$set: action.payload}
                }
            });

        case SHIPMENT_LINE_PRICE_UPDATED_BY_FORM:
            const shipmentLineIndexPricing = _.findIndex(state.shipment.lines, l => {
                return parseInt(l.id) === parseInt(action.payload.shipmentLineId);
            });

            if (shipmentLineIndexPricing > -1) {
                return update(state, {
                    shipment: {
                        lines: {
                            [shipmentLineIndexPricing]: {
                                order_line: {
                                    price: {$set: parseFloat(action.payload.price)}
                                }
                            }
                        }
                    }
                })
            }
            return state;

        case SHIPMENT_IS_FULFILLED:
            const fulfilledLines = _.cloneDeep(state.shipment.lines);
            _.each(fulfilledLines, line => {
                line.fulfilled = 1;
            });
            return update(state, {
                shipment: {
                    status: {$set: 'Shipped'},
                    lines: {$set: fulfilledLines}
                }
            });

        case TRANSACTION_DOC_NUMBER_UPDATED:
            const {id, number} = action.payload;
            const transactionIndex = _.findIndex(state.transaction_list.data, i => {
                return parseInt(i.id) === parseInt(id);
            });
            if (transactionIndex > -1) {
                return update(state, {
                    transaction_list: {
                        data: {
                            [transactionIndex]: {
                                invoice_number: {$set: number}
                            }
                        }
                    }
                })
            }
            return state;

        case SHIPMENT_IS_UNFULFILLED:
            const unfulfilledLines = _.cloneDeep(state.shipment.lines);
            _.each(unfulfilledLines, line => {
                line.unfulfilledLines = 0;
            });
            return update(state, {
                shipment: {
                    status: {$set: 'Pending'},
                    lines: {$set: unfulfilledLines}
                }
            });

        case SHIPMENT_LIST_FETCHED:
            return update(state, {
                list: {$set: action.payload}
            });

        case TRANSACTION_LIST_FETCHED: 
            return update(state, {
                transaction_list: {$set: action.payload}
            });

        case SHIPMENT_MODEL_LOADED:
            return update(state, {
                shipment: {$set: action.payload}
            });
            
        case SET_NEW_SHIPMENT_MODEL:
            return update(state, {
                model: {$set: action.payload}
            });

        case SHIPMENT_MODEL_UPDATED_BY_FORM:
            const {value, field} = action.payload;
            return update(state, {
                shipment: {
                    [field]: {$set: value}
                }
            });

        case NEW_SHIPMENT_MODEL_COMMENT_UPDATED_BY_FORM:
            return update(state, {
                model: {
                    comment: {$set: action.payload}
                }
            });
        
        case NEW_SHIPMENT_MODEL_HEADER_UPDATED_BY_FORM:
            return update(state, {
                model: {
                    header: {
                        [action.payload.fieldName]: {$set: action.payload.value}
                    }
                }
            });

        case NEW_SHIPMENT_MODEL_LINES_QUANTITY_UPDATED_BY_FORM:
            const shipmentLineIndex = _.findIndex(state.model.lines, line => {
                return _.parseInt(line.order_line_id) === _.parseInt(action.payload.lineId);
            });
            if (shipmentLineIndex > -1) {
                return update(state, {
                    model: {
                        lines: {
                            [shipmentLineIndex]: {
                                quantity: {$set: action.payload.quantity}
                            }
                        }
                    }
                });
            }
            return state;

        case SHIPMENT_INVOICE_DATE_UPDATED:
            return update(state, {
                shipment: {
                    invoice_date: {$set: action.payload}
                }
            });

        case SHIPMENT_ORDER_TAX_CODE_UPDATED:
            return update(state, {
                shipment: {
                    order: {
                        tax_id: {$set: action.payload}
                    }
                }
            });

        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/stores/shipment.js